import { mainTextWhite, padding20 } from '../../../theme';

const styles = () => ({
  root: {
    color: mainTextWhite,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    padding: `0 ${padding20}`,
    height: '100%',
    borderBottom: '3px solid transparent',
  },
  prefix: {
    fontWeight: 400,
  },
});

export default styles;
